export default function TopicHeader({topic, type}) {
    let text, specialStyleContainer = "", specialStyleTitle="", specialStyleContent = "";
    
    switch (type) {
        case "rubrique":
            text = `Retrouvez toute l'actu ${topic} de Troyes et de l'Aube`
            break;
        case "cities":
            text = `Retrouvez toute l'actu de la ville de ${topic}`
            break;
        case "chaine-ephemere":
            text = `Découvrez les articles de la chaîne ephémère ${topic}`
            break;
        case "searched":
            text = `Découvrez les articles pour la recherche : ${topic}`
            break;
        case "contact":
            text = "Vous avez une information ou une question pour nous ? N’hésitez pas à nous contacter !";
            specialStyleContainer = "bg-dark-blue px-32 pt-24";
            specialStyleTitle = "text-primary-white";
            specialStyleContent= "text-primary-white";
            break;
        case "aroundme":
            text = "Cliquez sur les points de la carte pour découvrir les reportages autour de vous.";
            specialStyleContainer = "bg-dark-blue px-32 pt-24";
            specialStyleTitle = "text-primary-white";
            specialStyleContent= "text-primary-white";
            break;
        default:
            break;
    }
    return (
        <div className={`topicHeader-container ${specialStyleContainer}`}>
            <h1 className={`topicHeader-title ${specialStyleTitle ? specialStyleTitle : "text-black"}`}>{topic}</h1>
            <p className={`topicHeader-content ${specialStyleContent ? specialStyleContent : "text-primary-grey"}`}>
                {text}
            </p>
        </div>
    )
}